export enum SolutionDocumentType {
    ValueCalculator = "ValueCalculator",
    BusinessCase = "BusinessCase",
    CaseStudy = "CaseStudy",
    OtherDocument = "OtherDocument"
}

export enum VEAnalysisStatus {
    InProgress = "InProgress",
    Completed = "Completed",
    Archived = "Archived"
}

export enum VEAnalysisMode {
    Test = "Test",
    Live = "Live"
}

export enum ValueCalculatorObjectKey {
    AnalysisDetails = "AnalysisDetails",
    SolutionScoping = "SolutionScoping",
    BusinessOutcome = "BusinessOutcome",
    PrimaryInput = "PrimaryInput",
    AdditionalInput = "AdditionalInput",
    SolutionPricing = "SolutionPricing",
    Investments = "Investments",
    ValueSummary = "ValueSummary",
    ValueCalculation = "ValueCalculation",
    InvestmentsVsBenefitsChart = "InvestmentsVsBenefitsChart",
    ProjectEconomics = "ProjectEconomics",
    ProjectCashflow = "ProjectCashflow",
    PowerOfOne = "PowerOfOne",
    GeneralNote = "GeneralNote",
    ContractDuration = "ContractDuration",
    ContractDurationUnit = "ContractDurationUnit",
    HasInvestmentNumbers = "HasInvestmentNumbers",
    PowerOfOneDriver = "PowerOfOneDriver",
    AnalysisDetailsMasterComment = "AnalysisDetailsMasterComment",
    SolutionScopingMasterComment = "SolutionScopingMasterComment",
    BusinessOutcomeMasterComment = "BusinessOutcomeMasterComment",
    PrimaryInputMasterComment = "PrimaryInputMasterComment",
    AdditionalInputMasterComment = "AdditionalInputMasterComment",
    SolutionPricingMasterComment = "SolutionPricingMasterComment",
    InvestmentsMasterComment = "InvestmentsMasterComment",
    ValueSummaryMasterComment = "ValueSummaryMasterComment",
    ValueCalculationMasterComment = "ValueCalculationMasterComment",
    BusineeCaseMasterComment = "BusineeCaseMasterComment",
    PowerOfOneMasterComment = "PowerOfOneMasterComment",
    TCOInput = "TCOInput",
    TCOInputMasterComment = "TCOInputMasterComment",
    TCOOutput = "TCOOutput",
    TCOOutputMasterComment = "TCOOutputMasterComment"
}

export enum BBService {
    CustomerInsights = "CustomerInsights",
    ValueEngine = "ValueEngine"
}

export enum SupportCaseStatus {
    Open = "Open",
    InProgress = "InProgress",
    Hold = "Hold",
    Close = "Close"
}

export enum UserRole {
    ITBAdmin = "ITBAdmin",
    ClientAdmin = "ClientAdmin",
    SolutionUser = "SolutionUser",
    GuestUser = "TempUser"
}

export enum UserStatus {
    Active = "Active",
    Terminated = "Terminated"
}

export enum ClientStatus {
    Active = "Active",
    Prospect = "Prospect",
    Terminated = "Terminated"
}

export enum ClientServiceType {
    FullyManaged = "FullyManaged",
    ClientManaged = "ClientManaged"
}

export enum SolutionUserRole {
    SolutionAdmin = "SolutionAdmin",
    User = "User",
    LightUser = "LightUser"
}

export enum SolutionUserStatus {
    Approved = "Approved",
    Rejected = "Rejected",
    Pending = "Pending",
    Revoked = "Revoked"
}

export enum ActivityLevel {
    ClientCreated = "ClientCreated",
    ClientUpdated = "ClientUpdated",
    ClientTerminated = "ClientTerminated",
    ClientActivated = "ClientActivated",
    ClientAdminChanged = "ClientAdminChanged",

    UserLoggedIn = "UserLoggedIn",
    TempUserLoggedIn = "TempUserLoggedIn",

    SolutionCreated = "SolutionCreated",
    SolutionStep1_1Performed = "SolutionStep1_1Performed",
    SolutionStep1_2Performed = "SolutionStep1_2Performed",
    SolutionStep1_3Performed = "SolutionStep1_3Performed",
    SolutionStep2Performed = "SolutionStep2Performed",
    SolutionStep3Performed = "SolutionStep3Performed",
    SolutionStep4Performed = "SolutionStep4Performed",
    SolutionStep5Performed = "SolutionStep5Performed",
    SolutionStatusChanged = "SolutionStatusChanged",
    SolutionActivated = "SolutionActivated",
    SolutionDeactivated = "SolutionDeactivated",
    SolutionVersionRestored = "SolutionVersionRestored",

    SolutionUserCreated = "SolutionUserCreated",
    SolutionAccessModified = "SolutionAccessModified",
    SelfRegisterSolutionUser = "SelfRegisterSolutionUser",
    SelfRegistrationRequestApproved = "SelfRegistrationRequestApproved",
    SelfRegistrationRequestRejected = "SelfRegistrationRequestRejected",
    RevokeSolutionAccess = "RevokeSolutionAccess",
    RequestSolutionAccess = "RequestSolutionAccess",
    UserTerminated = "UserTerminated",
    UserReactivated = "UserReactivated",

    VEAnalysis_CreateUpdatePerformed = "VEAnalysis_CreateUpdatePerformed",
    VEAnalysis_BasicSetupPerformed = "VEAnalysis_BasicSetupPerformed",
    VEAnalysis_BusinessOutcomePerformed = "VEAnalysis_BusinessOutcomePerformed",
    VEAnalysis_KeyInputPerformed = "VEAnalysis_KeyInputPerformed",
    VEAnalysis_PricingPerformed = "VEAnalysis_PricingPerformed",
    VEAnalysis_TCOInputPerformed = "VEAnalysis_TCOInputPerformed",
    VEAnalysis_TCOOutputPerformed = "VEAnalysis_TCOOutputPerformed",
    VEAnalysis_ValueSummaryPerformed = "VEAnalysis_ValueSummaryPerformed",
    VEAnalysis_ValueCalculationPerformed = "VEAnalysis_ValueCalculationPerformed",
    VEAnalysis_BusinessCasePerformed = "VEAnalysis_BusinessCasePerformed",
    VEAnalysis_PowerOfOnePerformed = "VEAnalysis_PowerOfOnePerformed",
    VEAnalysis_DocumentDownloaded = "VEAnalysis_DocumentDownloaded",
    VEAnalysis_Archived = "VEAnalysis_Archived",
    VEAnalysis_StatusChanged = "VEAnalysis_StatusChanged",

    VEAnalysis_LinkShared = "VEAnalysis_LinkShared",
    VEAnalysis_LinkOpened = "VEAnalysis_LinkOpened",
    VEAnalysis_SharedInputPerformed = "VEAnalysis_SharedInputPerformed",
    VEAnalysis_ExcelGeneratedForSharing = "VEAnalysis_ExcelGeneratedForSharing",
    VEAnalysis_SharedExcelUploaded = "VEAnalysis_SharedExcelUploaded",
    VEAnalysis_SharedPermissionChanged = "VEAnalysis_SharedPermissionChanged",
    VEAnalysis_ShareCancelled = "VEAnalysis_ShareCancelled",
    VEAnalysis_ShareExpiryExtended = "VEAnalysis_ShareExpiryExtended",

    SupportCaseResolutionPerformed = "SupportCaseResolutionPerformed",

    ClientDocumentsCreated = "ClientDocumentsCreated",
    ClientDocumentsUpdated = "ClientDocumentsUpdated",
    ClientDocumentsOrderChanged = "ClientDocumentsOrderChanged",
    ClientDocumentsDeleted = "ClientDocumentsDeleted",

    ClientDocumentCategoriesCreated = "ClientDocumentCategoriesCreated",
    ClientDocumentCategoriesUpdated = "ClientDocumentCategoriesUpdated",
    ClientDocumentCategoriesOrderChanged = "ClientDocumentCategoriesOrderChanged",
    ClientDocumentCategoriesDeleted = "ClientDocumentCategoriesDeleted",

    CIAnalysis_CreateUpdatePerformed = "CIAnalysis_CreateUpdatePerformed",
    CIAnalysis_IndustryPeerInputPerformed = "CIAnalysis_IndustryPeerInputPerformed",

    CIAnalysis_GetKYC_CompanySnapshotOutputPerformed = "CIAnalysis_GetKYC_CompanySnapshotOutputPerformed",
    CIAnalysis_GetKYC_PrioritiesInitiativesOutputPerformed = "CIAnalysis_GetKYC_PrioritiesInitiativesOutputPerformed",
    CIAnalysis_GetKYC_ChallengesRisksOutputPerformed = "CIAnalysis_GetKYC_ChallengesRisksOutputPerformed",
    CIAnalysis_GetKYC_FinancialsOutputPerformed = "CIAnalysis_GetKYC_FinancialsOutputPerformed",
    CIAnalysis_GetKYC_NewsOutputPerformed = "CIAnalysis_GetKYC_NewsOutputPerformed",

    CIAnalysis_GetZOI_TrendsOutputPerformed = "CIAnalysis_GetZOI_TrendsOutputPerformed",
    CIAnalysis_GetZOI_CompetitorInsightsOutputPerformed = "CIAnalysis_GetZOI_CompetitorInsightsOutputPerformed",
    CIAnalysis_GetZOI_CompanyPositionOutputPerformed = "CIAnalysis_GetZOI_CompanyPositionOutputPerformed",

    CIAnalysis_GetBPS_PersonaAlignmentOutputPerformed = "CIAnalysis_GetBPS_PersonaAlignmentOutputPerformed",
    CIAnalysis_GetBPS_ExecutiveShareholderSignalsOutputPerformed = "CIAnalysis_GetBPS_ExecutiveShareholderSignalsOutputPerformed",
    CIAnalysis_GetBPS_OpportunityVsRoadblocksOutputPerformed = "CIAnalysis_GetBPS_OpportunityVsRoadblocksOutputPerformed",
    CIAnalysis_GetBPS_SolutionPositioningOutputPerformed = "CIAnalysis_GetBPS_SolutionPositioningOutputPerformed",
}

export enum SolutionStatus {
    Test = "Test",
    Publish = "Publish"
}

export enum DomainBasedApprovalRole {
    LightUser = "LightUser",
    User = "User"
}

export enum ExcelObjectType {
    Table = "Table",
    Cellvalue = "Cellvalue"
}

export enum PowerPointObjectType {
    Table = "Table",
    PieChart = "PieChart",
    BarChart = "BarChart",
    LineChart = "LineChart",
    ComboChart = "ComboChart",
    DataPoint = "DataPoint"
}

export enum XLTableColumnType {
    UnFlagged = "UnFlagged",
    Visibility = "Visibility",
    Editable = "Editable",
    LowerLimit = "LowerLimit",
    UpperLimit = "UpperLimit",
    Default = "Default",
    Refresh = "Refresh",
    ValueType = "ValueType",
    DataType = "DataType",
    ClientSharing = "ClientSharing",
}

export enum XLCellDataType {
    Number = "Number",
    Currency = "Currency",
    Percentage = "Percentage",
    BooleanYesNo = "BooleanYesNo",
    BooleanTrueFalse = "BooleanTrueFalse",
    Date = "Date",
    TimeSpan = "TimeSpan",
    Text = "Text",
}

export enum XLHorizontalAlign {
    Left = "Left",
    Center = "Center",
    Right = "Right",
}

export enum XLVerticalAlign {
    Top = "Top",
    Middle = "Middle",
    Bottom = "Bottom",
}

export enum XLFontUnderlineType {
    Double = "Double",
    DoubleAccounting = "DoubleAccounting",
    None = "None",
    Single = "Single",
    SingleAccounting = "SingleAccounting",
}

export enum XLDefinedObject {
    Comment = "Comment",
    Other = "Other",
}

export enum XLCellSymbolPosition {
    Prefix = "Prefix",
    Suffix = "Suffix"
}

export enum ClientDocumentPageScope {
    Home = "Home",
    Tutorials = "Tutorials",
    Both = "Both",
}

export enum VCErrorSeverity {
    NoError = "NoError",
    Low = "Low",
    Mid = "Mid",
    High = "High"
}

export enum VEAnalysisLiskShareType {
    KeyInputsOnly = "KeyInputsOnly",
    WholeAnalysis = "WholeAnalysis"
}

export enum VEAnalysisAccessType {
    View = "View",
    Edit = "Edit"
}

export enum VEAnalysisAccessLogType {
    Viewed = "Viewed",
    Edited = "Edited"
}

export enum VEAnalysisShareStatus {
    Active = "Active",
    Expired = "Expired",
    Cancelled = "Cancelled"
}

export enum TempUserStatus {
    Active = "Active",
    Archived = "Archived",
    Suspended = "Suspended"
}

export enum NotificationType {
    Test = "Test",
    SharedKeyInputProvided = "SharedKeyInputProvided",

    ClientCreated = "ClientCreated",
    ClientCSMAssiged = "ClientCSMAssiged",
    ClientCSMUnassigned = "ClientCSMUnassigned",

    SolutionCreated = "SolutionCreated",
    SolutionAdminAssigned = "SolutionAdminAssigned",
    SolutionVersionChanged = "SolutionVersionChanged",
    SolutionDeactivated = "SolutionDeactivated",
    SolutionAccessRequested = "SolutionAccessRequested",
}

export enum NotificationLevel {
    High = "High",
    Mid = "Mid",
    Low = "Low",
}

export enum NotificationRaisedByUserType {
    User = "User",
    TempUser = "TempUser",
}

export enum SortType {
    OrderBy = "OrderBy",
    OrderByDescending = "OrderByDescending",
    ThenBy = "ThenBy",
    ThenByDescending = "ThenByDescending"
}

export enum CustomerInsightsStepName {
    IndustryAndPeers = "IndustryAndPeers"
}

export enum CustomerInsightsStepType {
    Input = "Input",
    Output = "Output"
}

export enum VEAnalysisVCModificationSource {
    LinkShareKeyInputsOnly = "LinkShareKeyInputsOnly",
    LinkShareWholeAnalysis = "LinkShareWholeAnalysis",
    DataCollectedExcelUpload = "DataCollectedExcelUpload",
    AnalysisRun = "AnalysisRun"
}